import {
  Component,
  Input,
  forwardRef,
  OnInit,
  input,
  output,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormsModule,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MdEditorOption, LMarkdownEditorModule } from 'ngx-markdown-editor';

@Component({
  selector: 'app-md-editor',
  imports: [LMarkdownEditorModule, FormsModule, ReactiveFormsModule],
  templateUrl: './md-editor.component.html',
  styleUrl: './md-editor.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MdEditorComponent),
      multi: true,
    },
  ],
})
export class MdEditorComponent implements ControlValueAccessor, OnInit {
  readonly placeholder = input<string>(
    'Escriba aquí el contenido de términos y condiciones en formato Markdown...',
  );
  readonly height = input<string>('300px');
  readonly showPreview = input<boolean>(true);
  @Input() formControl?: FormControl;
  readonly valueChange = output<string>();

  value: string = '';
  disabled: boolean = false;

  // Configuración del editor según la documentación
  get editorOptions(): MdEditorOption {
    return {
      showPreviewPanel: this.showPreview(),
      showBorder: false,
      hideIcons: [],
      usingFontAwesome5: false,
      scrollPastEnd: 0,
      enablePreviewContentClick: false,
      resizable: false,
      markedjsOpt: {
        sanitize: false,
        breaks: true,
      },
    };
  }

  // ControlValueAccessor implementation
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string): void {
    this.value = value || '';
    // Si hay un FormControl pasado como Input, sincronizarlo
    if (this.formControl && this.formControl.value !== this.value) {
      this.formControl.setValue(this.value, { emitEvent: false });
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onContentChange(value: string): void {
    this.value = value;

    // Emitir el cambio para uso sin formularios
    this.valueChange.emit(this.value);

    // Si hay un FormControl, actualizarlo
    if (this.formControl) {
      this.formControl.setValue(this.value);
    }

    // Para ControlValueAccessor
    this.onChange(this.value);
    this.onTouched();
  }

  ngOnInit(): void {
    // Si se pasa un FormControl, sincronizar el valor inicial
    if (this.formControl) {
      this.value = this.formControl.value || '';

      // Escuchar cambios en el FormControl
      this.formControl.valueChanges.subscribe((value: string) => {
        if (value !== this.value) {
          this.value = value || '';
        }
      });
    }
  }
}
